module.exports = __webpack_public_path__ + "img/venus-double.684431e3.svg";